/* announce-bar.js — announcement bar + language switcher.
   The switcher owns the site's text direction: picking Urdu or Arabic puts the
   document into RTL, which the [dir="rtl"] block in style.css mirrors.
   Generated by nothing — this file is hand-written, edit it directly. */
// (function () {
//   var RTL_LANGS = ['AR', 'UR'];
//   var STORE = 'tlx-lang';
//   var FONTS = {
//     UR: 'https://fonts.googleapis.com/css2?family=Noto+Nastaliq+Urdu:wght@400;500;600;700&display=swap',
//     AR: 'https://fonts.googleapis.com/css2?family=Noto+Naskh+Arabic:wght@400;500;600;700&display=swap'
//   };

//   function isRTL(code) { return RTL_LANGS.indexOf(code) > -1; }

//   /* Pull the script's stylesheet in on demand, so an English visitor never pays
//      for a font they cannot read. */
//   function loadFont(code) {
//     if (!FONTS[code] || document.getElementById('rtl-font')) return;
//     var l = document.createElement('link');
//     l.id = 'rtl-font';
//     l.rel = 'stylesheet';
//     l.href = FONTS[code];
//     document.head.appendChild(l);
//   }

//   function apply(code, persist) {
//     var d = document.documentElement;
//     var rtl = isRTL(code);
//     d.lang = code.toLowerCase();
//     d.dir = rtl ? 'rtl' : 'ltr';
//     d.classList.toggle('rtl', rtl);
//     if (rtl) loadFont(code);
//     if (persist) { try { localStorage.setItem(STORE, code); } catch (e) {} }

//     /* keep every switcher on the page in step */
//     document.querySelectorAll('.ann-switch').forEach(function (sw) {
//       var label = sw.querySelector('.ann-label');
//       if (label) label.textContent = code;
//       sw.querySelectorAll('.ann-dropdown button').forEach(function (b) {
//         b.classList.toggle('is-current', b.getAttribute('data-code') === code);
//       });
//     });

//     document.dispatchEvent(new CustomEvent('languagechange', {
//       detail: { code: code, rtl: rtl }
//     }));
//   }

//   function current() {
//     try { return localStorage.getItem(STORE) || 'EN'; } catch (e) { return 'EN'; }
//   }

//   document.querySelectorAll('.ann-switch').forEach(function (sw) {
//     var dd = sw.querySelector('.ann-dropdown');
//     if (!dd) return;
//     sw.addEventListener('click', function (e) {
//       var expanded = sw.getAttribute('aria-expanded') === 'true';
//       document.querySelectorAll('.ann-switch').forEach(function (o) {
//         o.setAttribute('aria-expanded', 'false');
//       });
//       sw.setAttribute('aria-expanded', expanded ? 'false' : 'true');
//       e.stopPropagation();
//     });
//     sw.addEventListener('keydown', function (e) {
//       if (e.key === 'Enter' || e.key === ' ') {
//         e.preventDefault();
//         sw.click();
//       } else if (e.key === 'Escape') {
//         sw.setAttribute('aria-expanded', 'false');
//       }
//     });
//     dd.querySelectorAll('button').forEach(function (btn) {
//       btn.addEventListener('click', function (e) {
//         e.stopPropagation();
//         var code = btn.getAttribute('data-code');
//         if (code) apply(code, true);
//         sw.setAttribute('aria-expanded', 'false');
//       });
//     });
//   });

//   document.addEventListener('click', function () {
//     document.querySelectorAll('.ann-switch').forEach(function (o) {
//       o.setAttribute('aria-expanded', 'false');
//     });
//   });

//   /* The inline head bootstrap has already set dir/lang to avoid a flash; this
//      syncs the switcher UI and loads the font once the DOM exists. */
//   apply(current(), false);
// })();

/* announce-bar.js — announcement bar + Shopify language switcher */
(function () {
  var RTL_LANGS = ['AR', 'UR'];
  var STORE = 'tlx-lang';

  var FONTS = {
    UR: 'https://fonts.googleapis.com/css2?family=Noto+Nastaliq+Urdu:wght@400;500;600;700&display=swap',
    AR: 'https://fonts.googleapis.com/css2?family=Noto+Naskh+Arabic:wght@400;500;600;700&display=swap'
  };
 
  /*
   * Check whether the selected language uses RTL direction.
   */
  function isRTL(code) {
    return RTL_LANGS.indexOf(code) > -1;
  }

  /*
   * Load the appropriate RTL font only when needed.
   */
  function loadFont(code) {
    if (!FONTS[code]) return;

    var existing = document.getElementById('rtl-font');

    if (existing) {
      existing.remove();
    }

    var link = document.createElement('link');

    link.id = 'rtl-font';
    link.rel = 'stylesheet';
    link.href = FONTS[code];

    document.head.appendChild(link);
  }

  /*
   * Apply language direction and keep the switcher UI synchronized.
   *
   * IMPORTANT:
   * This function does NOT translate page content.
   * Shopify Localization handles the actual locale/translation.
   */
   function applyDirection(code, persist) {
    var d = document.documentElement;

    /*
     * rtl fix - OLD: ye function khud direction decide karta tha:
     *
     *     var rtl = isRTL(code);
     *     d.lang = code.toLowerCase();
     *     d.dir  = rtl ? 'rtl' : 'ltr';
     *     d.classList.toggle('rtl', rtl);
     *
     * Masla: is ka faisla RTL_LANGS = ['AR','UR'] par tha, jab ke Liquid wali
     * list mein ar/he/fa/ur hain. Hebrew page par Liquid ne theek dir="rtl"
     * likha, phir ye chala, isRTL('HE') false nikla, aur dir wapas 'ltr' ho gaya.
     *
     * Ab direction ka ek hi maalik hai: server. Ye function sirf padhta hai ke
     * page RTL hai ya nahi, faisla nahi karta. Nayi language add karne par ab
     * sirf theme.liquid ki list badalni hogi - ye file khud-ba-khud chalti rahegi.
     */
    var rtl = d.dir === 'rtl';

    if (rtl) {
      loadFont(code);
    } else {
      var existingFont = document.getElementById('rtl-font');

      if (existingFont) {
        existingFont.remove();
      }
    }


    if (persist) {
      try {
        localStorage.setItem(STORE, code);
      } catch (e) {}
    }

    /*
     * Keep every language switcher on the page synchronized.
     */
    document.querySelectorAll('.ann-switch').forEach(function (sw) {
      var label = sw.querySelector('.ann-label');

      if (label) {
        label.textContent = code;
      }

      sw.querySelectorAll('.ann-dropdown button[name="locale_code"]').forEach(function (button) {
        var buttonCode = button.getAttribute('data-code');

        button.classList.toggle(
          'is-current',
          buttonCode === code
        );

        button.setAttribute(
          'aria-selected',
          buttonCode === code ? 'true' : 'false'
        );
      });
    });

    /*
     * Notify other scripts that the language direction changed.
     */
    document.dispatchEvent(
      new CustomEvent('languagechange', {
        detail: {
          code: code,
          rtl: rtl
        }
      })
    );
  }

  /*
   * Get the last selected language from localStorage.
   *
   * Shopify remains the source of truth for the actual page locale.
   */
 function current() {
  var l = document.documentElement.lang || 'en';
  return l.split('-')[0].toUpperCase();
}

  /*
   * Initialize every announcement-bar language switcher.
   */
  document.querySelectorAll('.ann-switch').forEach(function (sw) {
    var dd = sw.querySelector('.ann-dropdown');

    if (!dd) return;

    /*
     * Open / close the language dropdown.
     *
     * Clicking an actual language button is ignored here
     * so Shopify's localization form can submit normally.
     */
    sw.addEventListener('click', function (e) {
      if (e.target.closest('.ann-dropdown button[name="locale_code"]')) {
        return;
      }

      var expanded =
        sw.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.ann-switch').forEach(function (other) {
        other.setAttribute('aria-expanded', 'false');
      });

      sw.setAttribute(
        'aria-expanded',
        expanded ? 'false' : 'true'
      );

      e.stopPropagation();
    });

    /*
     * Keyboard accessibility for the language switcher.
     */
    sw.addEventListener('keydown', function (e) {
      if (e.target.closest('.ann-dropdown button[name="locale_code"]')) {
        return;
      }

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        sw.click();
      } else if (e.key === 'Escape') {
        sw.setAttribute('aria-expanded', 'false');
      }
    });

    /*
     * Shopify language buttons.
     *
     * DO NOT call preventDefault().
     *
     * The button is type="submit" and belongs to:
     *
     * {% form 'localization' %}
     *
     * Therefore Shopify receives:
     *
     * name="locale_code"
     * value="ur" / "ar" / "en" ...
     */
    dd.querySelectorAll('button[name="locale_code"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code');

        if (!code) return;

        /*
         * Save the selected language for the RTL/font bootstrap.
         */
        // try {
        //   localStorage.setItem(STORE, code);
        // } catch (e) {}

        // applyDirection(code, true);

        /*
         * Close the dropdown.
         */
        sw.setAttribute('aria-expanded', 'false');

        /*
         * IMPORTANT:
         * There is intentionally NO:
         *
         * e.preventDefault()
         *
         * Shopify must submit the localization form.
         */
      });
    });
  });

  /*
   * Close all language dropdowns when clicking outside.
   */
  document.addEventListener('click', function () {
    document.querySelectorAll('.ann-switch').forEach(function (sw) {
      sw.setAttribute('aria-expanded', 'false');
    });
  });

  /*
   * Apply the current/saved language when the script loads.
   */
  applyDirection(current(), false);
})();